/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import {
	Box,
	Button,
	Chip,
	CircularProgress,
	Collapse,
	IconButton,
	LinearProgress,
	TextField,
	Tooltip,
	Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { colors } from '../../../utils';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
import Table from '../../../components/table/Table';
import {
	setAllPosts,
	setPostCatList,
	setPostResourcesList,
} from '../../../redux/slices/posts/posts';
import { useLocation } from 'react-router-dom';
import { successNotify } from '../../../utils/helper';
import EditIcon from '@mui/icons-material/Edit';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import DeleteIcon from '@mui/icons-material/Delete';
import { setCompaniesList } from '../../../redux/slices/companies/companies';
import ReadMoreReact from 'read-more-react/dist/components/ReadMoreReact';
import moment from 'moment';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const Posts = () => {
	const dispatch = useDispatch();
	const location = useLocation();

	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { postCatList, postResourcesList, posts } = useSelector((state) => state?.posts);
	const { companiesList } = useSelector((state) => state?.companies);

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [isLoadingDoc, setIsLoadingDoc] = useState(false);
	const [imgName, setImgName] = useState('');
	const [docName, setDocName] = useState('');
	const [disableUpload, setDisableUpload] = useState(false);
	const [disableUrlInput, setDisableUrlInput] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);
	const [formData, setFormData] = useState({
		creator_id: '',
		creator_name: '',
		post_title: '',
		post_content: '',
		category_id: '',
		resource_id: '',
		image: '',
		url: '',
	});
	const [selectedDate, setSelectedDate] = useState(dayjs());
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});
	const [filters, setFilters] = useState({
		category_id: '',
		resource_id: '',
		creator_id: '',
		post_status: '',
		search: '',
		date_from: null,
		date_to: null,
	});
	const [filtersOpen, setFiltersOpen] = useState(false);
	let sendId =
		location.pathname === '/corporate-governance-library/legal-and-regulatory/posts' ? 1 : 2;

	const getPosts = async (limit, page, filterParams = filters) => {
		setIsLoading(true);
		try {
			await Api.post(
				endPoints?.posts?.fetch,
				{
					clientId: filterParams.creator_id || null,
					userId: null,
					category_id: filterParams.category_id || null,
					resource_id: filterParams.resource_id || null,
					nav_id: sendId,
					post_status: filterParams.post_status || null,
					search: filterParams.search || null,
					date_from: filterParams.date_from
						? dayjs(filterParams.date_from).format('YYYY-MM-DD')
						: null,
					date_to: filterParams.date_to
						? dayjs(filterParams.date_to).format('YYYY-MM-DD')
						: null,
					limit: limit || 10,
					page: page || 1,
				},
				{
					headers: {
						'xt-user-token': null,
					},
				},
			)
				.then((response) => {
					dispatch(
						setAllPosts(
							response?.data?.data?.posts?.posts?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								title: d?.post_title,
								description: d?.post_content,
								post_status: d?.post_status,
								image: d?.image,
								category_id: d?.category_id,
								dt: d?.post_date,
								date: d?.date,
								url: d?.url,
								creator_id: d?.creator_id,
								is_enabled: d?.is_enabled,
								category_name: d?.category_name,
								creator_name: d?.creator_name,
								resource_id: d?.resource_id,
								resource_name: d?.resource_name,
							})),
						),
					);
					const { page, limit, totalPages, totalRecords } =
						response?.data?.data?.posts?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false);
				})
				.catch((error) => {});
		} catch (err) {}
	};
	const getCategories = async () => {
		try {
			await Api.post(
				endPoints?.posts?.getCategories,
				{
					category_nav_id: sendId,
					limit: 20,
					page: 1,
				},
				{
					headers: {
						'xt-user-token': null,
					},
				},
			)
				.then((response) => {
					dispatch(
						setPostCatList(
							response?.data?.data?.postCategories?.post_categories.map((d) => ({
								id: d?.id,
								description: d?.name,
							})),
						),
					);
				})
				.catch((error) => {});
		} catch (err) {}
	};
	const getPostResources = async () => {
		try {
			await Api.post(
				endPoints?.posts?.getResources,
				{
					category_nav_id: sendId,
					limit: 20,
					page: 1,
				},
				{
					headers: {
						'xt-user-token': null,
					},
				},
			)
				.then((response) => {
					dispatch(
						setPostResourcesList(
							response?.data?.data?.resources?.resources?.map((d) => ({
								id: d?.id,
								description: d?.name,
							})),
						),
					);
				})
				.catch((error) => {});
		} catch (err) {}
	};
	const getAllCompanies = async () => {
		setIsLoading(true);
		try {
			await Api.post(
				endPoints?.companies?.list,
				{
					limit: 1000,
					page: 1,
					columns: '*',
					sortby: 'ASC',
					orderby: 'id',
					where: 'id ^!= ^$1 AND displayed = false order by id',
					values: 0,
				},
				{
					headers: {
						'xt-user-token': null,
					},
				},
			)
				.then((response) => {
					dispatch(
						setCompaniesList(
							response?.data?.data?.clients?.clients?.map((d, index) => ({
								id: d?.id,
								description: d?.company_name,
							})),
						),
					);
					setIsLoading(false);
				})
				.catch((error) => {});
			setIsLoading(false);
		} catch (error) {}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		setFormData({
			post_title: '',
			post_content: '',
			category_id: '',
			image: '',
			url: '',
			creator_id: '',
			creator_name: '',
		});
		setImgName('');
		setDocName('');
		setDisableUrlInput(false);
		setIsEditing(false);
	};
	const handleCloseDeleteModal = () => {
		setFormData({
			post_title: '',
			post_content: '',
			category_id: '',
			image: '',
			url: '',
			creator_id: '',
			creator_name: '',
		});
		setOpenDeleteModal(false);
	};

	const handleEditModal = (val) => {
		setOpenModal(val);
		setFormData({
			id: val.id,
			post_title: val.title,
			post_content: val.description,
			image: val.image,
			url: val.url,
			category_id: val.category_id,
			creator_id: val.creator_id,
			creator_name: val.creator_name,
			resource_id: val.resource_id,
		});
		setSelectedDate(val.date);
		setIsEditing(true);
	};

	const handleOpenDeleteModal = (val) => {
		setFormData({ id: val.id });
		setOpenDeleteModal(true);
	};

	const handleChange = (e) => {
		if (e.target.name === 'creator_id') {
			const matchingCompany = companiesList.find((company) => company.id === e.target.value);
			if (matchingCompany) {
				setFormData((prevState) => ({
					...prevState,
					creator_name: matchingCompany.description,
				}));
			}
		}
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
		if (e.target.name == 'url' && e.target.value) {
			setDisableUpload(true);
			setDisableUrlInput(false);
		} else {
			setDisableUpload(false);
			setDisableUrlInput(false);
		}
	};

	const statusOptions = [
		{
			id: 'publish',
			description: 'Publish',
		},
		{
			id: 'private',
			description: 'Private',
		},
		{
			id: 'draft',
			description: 'Draft',
		},
		{
			id: 'pending',
			description: 'Pending',
		},
	];

	const handleFilterChange = (e) => {
		setFilters((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleFilterDateChange = (name, value) => {
		setFilters((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handleApplyFilters = () => {
		getPosts(currentParams.limit, 1, filters);
	};

	const handleClearFilters = () => {
		const clearedFilters = {
			category_id: '',
			resource_id: '',
			creator_id: '',
			post_status: '',
			search: '',
			date_from: null,
			date_to: null,
		};
		setFilters(clearedFilters);
		getPosts(currentParams.limit, 1, clearedFilters);
	};

	const handleImageUpload = (event) => {
		setIsLoadingImg(true);
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			setImgName(fileName);

			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null,
				},
			})
				.then((response) => {
					setIsLoadingImg(false);
					setFormData((prevState) => ({
						...prevState,
						image: response.data.data.link,
					}));
					successNotify('Image Uploaded Successfully');
				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});

			// setErrMsg('Login Failed');
		}
	};
	const handleDocsUpload = (event) => {
		setIsLoadingDoc(true);
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			setDocName(fileName);
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null,
				},
			})
				.then((response) => {
					setFormData((prevState) => ({
						...prevState,
						url: response.data.data.link,
					}));
					setIsLoadingDoc(false);
					setDisableUrlInput(true);
					setDisableUpload(false);
					successNotify('Document Uploaded Successfully');
				})
				.catch((error) => {});
		}
	};

	const handleSubmit = async () => {
		setIsLoadingModal(true);
		if (!isEditing) {
			try {
				const data = {
					...formData,
					nav_id: sendId,
					post_status: 'pending',
					date: dayjs(selectedDate).format('YYYY-MM-DD'),
				};

				await Api.post(endPoints?.posts?.create, data, {
					headers: {
						'xt-user-token': null,
					},
				})
					.then((response) => {
						handleCloseModal();
						successNotify('Post Created Successfully');
						getPosts();
						setIsLoadingModal(false);
					})
					.catch((error) => {});
			} catch (err) {}
		} else {
			try {
				const data = {
					...formData,
					post_status: 'pending',
					date: dayjs(selectedDate).format('YYYY-MM-DD'),
				};

				await Api.post(endPoints?.posts?.update, data, {
					headers: {
						'xt-user-token': null,
					},
				})
					.then((response) => {
						handleCloseModal();
						successNotify('Post Updated Successfully');
						getPosts();
						setIsLoadingModal(false);
					})
					.catch((error) => {});
			} catch (err) {}
		}
	};

	const handleDelete = async () => {
		try {
			await Api.post(
				endPoints?.posts?.delete,
				{
					...formData,
				},
				{
					headers: {
						'xt-user-token': null,
					},
				},
			)
				.then((response) => {
					handleCloseDeleteModal();
					successNotify('Post Deleted Successfully');
					getPosts();
				})
				.catch((error) => {});
		} catch (err) {}
	};

	const handleSwitchClick = (event) => {
		event.stopPropagation();
	};
	const handleChangeTableSwitch = async (event, val) => {
		// try {
		// 	await Api.post(endPoints?.posts?.delete, {
		// 		id: val.id,
		// 		status: event.target.checked
		// 	}, {
		// 		headers: {
		// 			'xt-user-token': null
		// 		}
		// 	})
		// 		.then((response) => {
		// 			handleCloseDeleteModal();
		// 			successNotify("Post Deleted Successfully")
		// 			getPosts();
		// 		})
		// 		.catch((error) => {
		// 		});
		// } catch (err) {
		// }
	};

	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		{
			title: 'Title',
			field: 'title',
			width: '10%',
			render: (rowData) => (
				<h4 className='font-face-R'>
					{rowData?.title?.length > 15 ? (
						<ReadMoreReact
							text={rowData?.title}
							min={10}
							ideal={15}
							max={rowData?.title?.length}
							readMoreText='Read More'
						/>
					) : (
						rowData?.title
					)}
				</h4>
			),
		},
		{
			title: 'Description',
			field: 'description',
			render: (rowData) => (
				<h4 className='font-face-R'>
					{rowData?.description?.length > 15 ? (
						<ReadMoreReact
							text={rowData?.description}
							min={10}
							ideal={15}
							max={rowData?.description?.length}
							readMoreText='Read More'
						/>
					) : (
						rowData?.description
					)}
				</h4>
			),
		},
		{
			title: 'Category',
			field: 'category_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.category_name}</h4>,
		},
		{
			title: 'Status',
			field: 'post_status',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.post_status}</h4>,
		},
		{
			title: 'Image',
			field: 'image',
			render: (rowData) => <img src={rowData?.image} height='60' width='60' />,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => (
				<h4 className='font-face-R'>{moment(rowData?.dt).format('DD-MM-YYYY')}</h4>
			),
		},
		{
			title: 'Creator',
			field: 'creator_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.creator_name}</h4>,
		},
		{
			title: 'Resource',
			field: 'resource_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.resource_name}</h4>,
		},
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		// {
		// 	title: 'Status',
		// 	field: 'enabled',
		// 	render: (rowData) =>
		// 		<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, rowData)} checked={rowData?.is_enabled} name='enabled' />,
		// },
		{
			title: 'Delete',
			field: 'delete',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Delete'>
					<IconButton onClick={() => handleOpenDeleteModal(rowData)} aria-label='Delete'>
						<DeleteIcon />
					</IconButton>
				</Tooltip>
			),
		},
	];
	const handleOnChangeDate = (dt) => {
		setSelectedDate(dt);
	};

	useEffect(() => {
		getPosts();
		getCategories();
		getPostResources();
		getAllCompanies();
	}, [sendId]);
	return (
		<>
			<Card margin='3rem 1.5rem' padding='3rem'>
				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom btnTitle='Create Post' onClickHandler={() => setOpenModal(true)} />
				</Flex>

				{/* Filters Section */}
				<Box sx={{ mb: 3, backgroundColor: '#f5f5f5', borderRadius: '8px', overflow: 'hidden' }}>
					{/* Filter Header - Clickable */}
					<Box
						sx={{
							p: 2,
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							'&:hover': { backgroundColor: '#ebebeb' },
							transition: 'background-color 0.2s ease'
						}}
						onClick={() => setFiltersOpen(!filtersOpen)}
					>
						<Flex ai='center' gap='0.5rem'>
							<FilterListIcon sx={{ color: '#666' }} />
							<Typography variant='h6' sx={{ fontSize: '1.6rem', fontWeight: 600, color: '#333' }}>
								Filter Posts
							</Typography>
						</Flex>
						{filtersOpen ? <ExpandLessIcon sx={{ color: '#666' }} /> : <ExpandMoreIcon sx={{ color: '#666' }} />}
					</Box>

					<Collapse in={filtersOpen} timeout={300}>
						<Box sx={{ p: 2, pt: 1 }}>
							{/* Clear All Button */}
							<Flex jc='flex-end' mb='1rem'>
								<Button
									variant='text'
									startIcon={<ClearIcon />}
									onClick={handleClearFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', color: '#666' }}>
									Clear All
								</Button>
							</Flex>

							{/* Quick Category Filters */}
							<Box sx={{ mb: 2 }}>
								<Typography sx={{ fontSize: '1.2rem', color: '#666', mb: 1 }}>
									Quick Filters:
								</Typography>
								<Flex gap='0.8rem' fw='wrap'>
									{postCatList?.map((cat) => (
										<Chip
											key={cat.id}
											label={cat.description}
											onClick={() => {
												setFilters((prev) => ({ ...prev, category_id: cat.id }));
												getPosts(currentParams.limit, 1, { ...filters, category_id: cat.id });
											}}
											color={filters.category_id === cat.id ? 'success' : 'default'}
											variant={filters.category_id === cat.id ? 'filled' : 'outlined'}
											sx={{ fontSize: '1.1rem', cursor: 'pointer' }}
										/>
									))}
								</Flex>
							</Box>

							{/* Search Bar */}
							<Box sx={{ mb: 2 }}>
								<InputControl
									state={filters.search}
									onChange={handleFilterChange}
									label='Search by Title'
									name='search'
									InputProps={{
										startAdornment: <SearchIcon sx={{ color: '#999', mr: 1 }} />,
									}}
								/>
							</Box>

							{/* Dropdown Filters */}
							<Grid gtc='repeat(auto-fit, minmax(18rem, 1fr))' gap='1.5rem'>
								<FilledSelectOption
									label='Category'
									state={filters.category_id}
									onChange={handleFilterChange}
									options={postCatList}
									maxWidth='100%'
									minWidth='100%'
									width='100%'
									name='category_id'
								/>
								<FilledSelectOption
									label='Resource'
									state={filters.resource_id}
									onChange={handleFilterChange}
									options={postResourcesList}
									maxWidth='100%'
									minWidth='100%'
									width='100%'
									name='resource_id'
								/>
								<FilledSelectOption
									label='Creator'
									state={filters.creator_id}
									onChange={handleFilterChange}
									options={companiesList}
									maxWidth='100%'
									minWidth='100%'
									width='100%'
									name='creator_id'
								/>
								<FilledSelectOption
									label='Status'
									state={filters.post_status}
									onChange={handleFilterChange}
									options={statusOptions}
									maxWidth='100%'
									minWidth='100%'
									width='100%'
									name='post_status'
								/>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date From'
										value={filters.date_from}
										onChange={(value) => handleFilterDateChange('date_from', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date To'
										value={filters.date_to}
										onChange={(value) => handleFilterDateChange('date_to', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
							</Grid>

							{/* Apply Button */}
							<Flex jc='flex-end' gap='1rem' mt='1.5rem'>
								<Button
									variant='contained'
									color='success'
									startIcon={<SearchIcon />}
									onClick={handleApplyFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', px: 3 }}>
									Apply Filters
								</Button>
							</Flex>
						</Box>
					</Collapse>
				</Box>

				<TransitionsModal
					open={openModal}
					// handleOpen={handleOpenModal}
					handleClose={handleCloseModal}
					modalTitle={isEditing ? 'Update Post' : 'Create Post'}
					isLoading={isLoadingModal}
					// submitHandler={leaveApprovedHandler}
					// submitDisabledBtn={leaveApprovedDis}
				>
					<Grid
						gtc='repeat(auto-fit, minmax(35rem, 1fr))'
						margin='2.5rem 0'
						padding='2rem'>
						{/* <MarginHandler width='100%'> */}
						<InputControl
							state={formData?.post_title}
							onChange={handleChange}
							// inputProps={{ maxLength: 150 }}
							label='Title'
							name='post_title'
						/>
						{/* </MarginHandler> */}
						{/* <MarginHandler width='100%'> */}
						<InputControl
							state={formData?.post_content}
							onChange={handleChange}
							// inputProps={{ maxLength: 250 }}
							label='Description'
							name='post_content'
						/>
						{/* </MarginHandler> */}
						{/* <FilledSelectOption
								label='Select Status'
								initalStateNotShow
								state={formData.post_status}
								onChange={handleChange}
								options={statusOptions}
								maxWidth='100%'
								minWidth='100%'
								width='100%'
								name='post_status'
							/> */}
						<FilledSelectOption
							label='Select Category'
							initalStateNotShow
							state={formData.category_id}
							onChange={handleChange}
							options={postCatList}
							maxWidth='100%'
							minWidth='100%'
							width='100%'
							name='category_id'
						/>
						<FilledSelectOption
							label='Select Resource'
							initalStateNotShow
							state={formData.resource_id}
							onChange={handleChange}
							options={postResourcesList}
							maxWidth='100%'
							minWidth='100%'
							width='100%'
							name='resource_id'
						/>
						<FilledSelectOption
							label='Created By'
							initalStateNotShow
							state={formData.creator_id}
							onChange={handleChange}
							options={companiesList}
							maxWidth='100%'
							minWidth='100%'
							width='100%'
							name='creator_id'
						/>
						<MarginHandler width='100%'>
							<InputControl
								state={formData?.url}
								onChange={handleChange}
								disabled={disableUrlInput}
								label='Document Url'
								name='url'
							/>
						</MarginHandler>

						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<Box sx={{ alignItems: 'center', display: 'flex' }}>
								<DesktopDatePicker
									sx={{ m: '10px 10px 10px 0px' }}
									label={`Select Published Date`}
									value={selectedDate}
									onChange={(e) => handleOnChangeDate(e)}
									renderInput={(params) => <TextField {...params} />}
								/>
								{/* <Button text="x" onClick={() => deleteTimePicker(index)} /> */}
							</Box>
						</LocalizationProvider>

						{isLoadingImg ? (
							<CircularProgress sx={{ margin: 'auto' }} color='success' />
						) : (
							<>
								<input
									accept='.jpeg, .jpg, .png'
									style={{ display: 'none' }}
									id='image-upload'
									type='file'
									onChange={(event) => handleImageUpload(event)}
								/>
								<label htmlFor='image-upload'>
									<Button
										variant='contained'
										component='span'
										fullWidth
										color='success'
										style={{ fontSize: '1em' }}>
										Upload Image
									</Button>
								</label>
								{/* {imgName && <p style={{ textAlign: "center", fontSize: "13px" }}>{imgName}</p>} */}
								{formData?.image && (
									<img
										height={100}
										style={{ margin: 'auto' }}
										src={formData?.image}
									/>
								)}
							</>
						)}
						{/* <MarginHandler width='50%'> */}

						{isLoadingDoc ? (
							<CircularProgress sx={{ margin: 'auto' }} color='success' />
						) : (
							<>
								<input
									accept='file/*'
									style={{ display: 'none' }}
									id='doc-upload'
									type='file'
									onChange={(event) => handleDocsUpload(event)}
									disabled={disableUpload}
								/>
								<label htmlFor='doc-upload'>
									<Button
										variant='contained'
										component='span'
										fullWidth
										color='success'
										style={{ fontSize: '1em' }}
										disabled={disableUpload}>
										Upload Document
									</Button>
								</label>
								{docName && (
									<p style={{ textAlign: 'center', fontSize: '13px' }}>
										{docName}
									</p>
								)}
							</>
						)}
					</Grid>
					<MarginHandler mt='2rem'>
						<Button
							color='primary'
							variant='contained'
							onClick={handleSubmit}
							style={{
								background: colorGreenGradient,
								fontSize: '1.6rem',
								textTransform: 'none',
								padding: '0.7rem 2rem',
								margin: '0 1em 1em 0',
								color: colorWhite,
								borderRadius: '0.5rem',
								float: 'right',
							}}
							className='font-face-R'
							disabled={
								!formData.category_id ||
								!formData.post_title ||
								!formData.creator_id ||
								!formData.resource_id
							}>
							{isEditing ? 'Update Post' : 'Create Post'}
						</Button>
					</MarginHandler>
				</TransitionsModal>

				{isLoading ? (
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color='success' />
					</Box>
				) : (
					<Table
						columns={column}
						tableData={posts?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding='3rem'
						showTitle
						paginationType='normal'
						titleHeading='Posts'
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) =>
							getPosts(parseInt(event.target.value, 10), 1)
						}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) =>
							getPosts(currentParams.limit, newPage + 1)
						}
						curPage={currentParams.page - 1}
					/>
				)}

				<DeleteModal
					open={openDeleteModal}
					handleClose={handleCloseDeleteModal}
					handleDelete={handleDelete}
				/>
			</Card>
		</>
	);
};

export default Posts;
